
    import './styles.scoped.css';
    export default {
  "root": "awsui_root_1wzqe_l8oe3_145",
  "search-field": "awsui_search-field_1wzqe_l8oe3_177",
  "input-wrapper": "awsui_input-wrapper_1wzqe_l8oe3_184",
  "add-token": "awsui_add-token_1wzqe_l8oe3_191",
  "tokens": "awsui_tokens_1wzqe_l8oe3_198",
  "token-operator": "awsui_token-operator_1wzqe_l8oe3_203",
  "property-editor": "awsui_property-editor_1wzqe_l8oe3_207",
  "property-editor-header": "awsui_property-editor-header_1wzqe_l8oe3_210",
  "property-editor-header-enum": "awsui_property-editor-header-enum_1wzqe_l8oe3_223",
  "property-editor-form": "awsui_property-editor-form_1wzqe_l8oe3_238",
  "property-editor-cancel": "awsui_property-editor-cancel_1wzqe_l8oe3_243",
  "property-editor-actions": "awsui_property-editor-actions_1wzqe_l8oe3_246",
  "property-editor-enum": "awsui_property-editor-enum_1wzqe_l8oe3_254",
  "token-editor": "awsui_token-editor_1wzqe_l8oe3_259",
  "token-editor-form": "awsui_token-editor-form_1wzqe_l8oe3_266",
  "token-editor-field-property": "awsui_token-editor-field-property_1wzqe_l8oe3_269",
  "token-editor-field-operator": "awsui_token-editor-field-operator_1wzqe_l8oe3_272",
  "token-editor-field-value": "awsui_token-editor-field-value_1wzqe_l8oe3_275",
  "token-editor-multiselect-wrapper": "awsui_token-editor-multiselect-wrapper_1wzqe_l8oe3_278",
  "token-editor-multiselect-wrapper-inner": "awsui_token-editor-multiselect-wrapper-inner_1wzqe_l8oe3_283",
  "token-editor-cancel": "awsui_token-editor-cancel_1wzqe_l8oe3_287",
  "token-editor-submit": "awsui_token-editor-submit_1wzqe_l8oe3_290",
  "token-editor-actions": "awsui_token-editor-actions_1wzqe_l8oe3_293",
  "token-editor-grid": "awsui_token-editor-grid_1wzqe_l8oe3_302",
  "token-editor-grid-group": "awsui_token-editor-grid-group_1wzqe_l8oe3_336",
  "token-editor-narrow": "awsui_token-editor-narrow_1wzqe_l8oe3_339",
  "token-editor-supports-groups": "awsui_token-editor-supports-groups_1wzqe_l8oe3_348",
  "token-editor-grid-header": "awsui_token-editor-grid-header_1wzqe_l8oe3_352",
  "token-editor-grid-cell": "awsui_token-editor-grid-cell_1wzqe_l8oe3_358",
  "token-editor-add-token": "awsui_token-editor-add-token_1wzqe_l8oe3_367",
  "custom-content-wrapper": "awsui_custom-content-wrapper_1wzqe_l8oe3_371",
  "custom-control": "awsui_custom-control_1wzqe_l8oe3_375",
  "input": "awsui_input_1wzqe_l8oe3_184",
  "results": "awsui_results_1wzqe_l8oe3_383",
  "token-trigger": "awsui_token-trigger_1wzqe_l8oe3_388",
  "remove-all": "awsui_remove-all_1wzqe_l8oe3_393",
  "join-operation": "awsui_join-operation_1wzqe_l8oe3_394",
  "custom-filter-actions": "awsui_custom-filter-actions_1wzqe_l8oe3_395",
  "constraint": "awsui_constraint_1wzqe_l8oe3_399"
};
  